export default __webpack_public_path__ + "static/media/slide-1.1efed595.png";